import {isEmpty, omitBy} from 'lodash'
import querystring from 'querystring'

import {getCleanSearch} from './window-location'

export const paramsFromLocation = () => querystring.parse(getCleanSearch())
export const addQuery = (url: string, query: any = {}) => {
  const [base, existingQuery] = url.split('?')
  const newQuery = querystring.stringify({
    ...querystring.parse(existingQuery || ''),
    ...omitBy(query, a => !a && a !== 0),
  })
  return [base, newQuery].filter(a => !isEmpty(a)).join('?')
}

export const ensureURLProtocol = (url: string) => (/^https?:\/\/.*/.test(url) ? url : `https://${url}`)
